import * as React from 'react';

import PropTypes from 'prop-types';

import {LocationEmptyView} from '../../core/search/location-empty-view';
import {LocationFound} from '../../core/search/location-found';
import {LocationResult} from '../../core/search/location-result';
import getClassesMixin from '../../mixins/get-classes';

import InputAjaxSearch from '../input-ajax-search';

export class LocationAjaxSearch extends React.Component {
    getClasses = getClassesMixin;

    static propTypes = {
        accessToken: PropTypes.string.isRequired,
        placeholder: PropTypes.string,
        onSelect: PropTypes.func.isRequired,
    };

    render() {
        const classes = this.getClasses('ui-location-search');

        return (
            <InputAjaxSearch
                className={classes}
                placeholder={this.props.placeholder}
                popoverClass='location'
                foundResultComponent={LocationFound}
                shouldOpenOnFocus={false}
                emptyView={LocationEmptyView}
                updateQueryOnSelect={true}
                onSelect={this.props.onSelect}
                renderRow={this.renderLocation}
                search={this.search}
            />
        );
    }

    search = (q, callback) => {
        const endpoint = 'https://api.tiles.mapbox.com/v4/geocode/mapbox.places';
        const uri = `${endpoint}/${encodeURIComponent(q)}.json?access_token=${
            this.props.accessToken
        }`;

        $.getJSON(uri, null).then(({features}) => {
            const locations = features
                .filter((feature) => feature.geometry && feature.geometry.coordinates)
                .map((feature) => ({
                    locationString: feature.place_name,
                    coordinates: feature.geometry.coordinates.join(','),
                }));

            callback(locations);
        });
    };

    renderLocation = (result, highlighted) => {
        return (
            <LocationResult
                key={result.locationString}
                locationResult={result}
                isSelected={highlighted}
            />
        );
    };
}
